import React from 'react';
import { Modal } from '@mui/material';
import { Button } from './index';
import { ExclamationIcon } from '@heroicons/react/solid';
import { InlineLoader } from '../Loader';

const DeleteConfirmationModal = ({ 
  open, 
  onClose, 
  onDelete, 
  title = "Delete Confirmation", 
  message = "Are you sure you want to delete this item? This action cannot be undone.",
  isLoading = false
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="delete-confirmation-title"
      aria-describedby="delete-confirmation-description"
    >
      <div className="w-[400px] bg-white absolute left-1/2 -translate-x-1/2 top-[30%] p-6 rounded-md">
        <div className="flex items-center justify-center mb-4 text-red-600">
          <ExclamationIcon className="h-12 w-12" />
        </div>
        
        <h2 className="text-xl font-bold mb-2 text-center">{title}</h2>
        <p className="text-center text-gray-600 mb-6">{message}</p>
        
        <div className="flex justify-center space-x-4">
          <Button 
            variant="ghost" 
            onClick={onClose} 
            disabled={isLoading}
            className="px-6"
          >
            Cancel
          </Button>
          <Button 
            onClick={onDelete} 
            disabled={isLoading}
            className="bg-red-600 hover:bg-red-700 px-6"
          >
            {isLoading ? (
              <>
                <InlineLoader className="text-white mr-2" />
                Deleting...
              </>
            ) : (
              "Delete"
            )}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationModal;
